import { Chip } from '@material-ui/core';
import { Product, StockInfo as StockInfoType } from '@setvi/shared/interfaces';

interface StockInfoProps {
  stockInfo: Product['stockInfo'];
}

/**
 * A product is considered "Non-Stocked" when it is not stocked in all warehouses
 * and none of its warehouses holds stock. This mirrors the condition behind the
 * "Not Stocked" badge in getStockInfo below - keep both in sync.
 */
export const isNonStocked = (stockInfo?: StockInfoType) => {
  if (!stockInfo) return false;

  const { allWarehouses = false, warehouses } = stockInfo;

  if (allWarehouses) return false;

  return !warehouses?.some(warehouse => warehouse.stock);
};

export const getStockInfo = ({
  allWarehouses = false,
  warehouses
}: Product['stockInfo']) => {
  if (allWarehouses) return 'Stocked';

  const warehousesWithStock = warehouses.filter(warehouse => warehouse.stock);

  if (warehousesWithStock?.length > 0)
    return `Stocked - ${warehousesWithStock?.[0]?.warehouseName}`;

  return 'Not Stocked';
};

export const StockInfo = ({ stockInfo }: StockInfoProps) => {
  if (!stockInfo) return null;

  return (
    <Chip variant="outlined" size="small" label={getStockInfo(stockInfo)} />
  );
};
